import { useState, useCallback } from 'react';

export const useResumeProcessing = (isLoggedIn, userId, history, setProgressModal, currentHistoryId = null) => {
  
  // 분석 취소 확인 모달 상태만 유지 (실제 사용되는 기능)
  const [analysisCancelDialogOpen, setAnalysisCancelDialogOpen] = useState(false);

  // 분석 취소 핸들러 (실제 사용되는 기능)
  const handleAnalysisCancel = async (targetHistoryId = null) => {
    // 분석 취소 기능은 백그라운드 처리로 이관됨
    return;
  };

  return {
    handleAnalysisCancel,
    analysisCancelDialogOpen,
    setAnalysisCancelDialogOpen
  };
}; 